import React from 'react'
import agent from '../agent'
import TransactionList from './widgets/TransactionList';
import CommitTransactionList from './widgets/CommitTransactionList';
import { connect } from 'react-redux'
import Pager from 'react-pager'
import {
    BTC_COMMIT_TRANSACTION_LIST_PAGE_LOADED,
    BTC_COMMIT_TRANSACTION_LIST_PAGE_UNLOADED
} from '../constants/actionTypes'

const mapStateToProps = state => ({
    ...state.transaction,
    appName: state.common.appName,
    token: state.common.token
});

const mapDispatchToProps = dispatch => ({
    onLoad: (payload) =>
        dispatch({ type: BTC_COMMIT_TRANSACTION_LIST_PAGE_LOADED, payload }),

    onUnload: () =>
        dispatch({ type: BTC_COMMIT_TRANSACTION_LIST_PAGE_UNLOADED })
});

class EthCommitTransactions extends React.Component {
    componentWillMount() {
        this.props.onLoad(agent.Users.getCommitTransactions(this.props.match.params.key, 'btc'));
    }

    componentWillUnmount() {
        this.props.onUnload();
    }

    render() {

        return (
            <div class='pane'>
                <div>
                    <h1>BTC Transactions list</h1>
                    <CommitTransactionList transactions={this.props.ex_transactions} loading={this.props.loading} />
                </div>
                <div>
                    <h1>SPNC Transactions list</h1>
                    <TransactionList transactions={this.props.spnc_transactions} loading={this.props.loading} />
                </div>
                <div>
                    <h1>SPNC local Transactions list</h1>
                    <TransactionList transactions={this.props.spnc_local_transactions} loading={this.props.loading} />
                </div>
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(EthCommitTransactions);



// WEBPACK FOOTER //
// ./src/components/BtcCommitTransactions.js